import React, { useRef, Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { addOverlay, removeOverlay } from "../../Actions/Overlay.action";

export default ({ blockSectionColumnSize = 6, open, blockElements, onMegaMenuClose, onMouseOverMegaMenu, onMouseLeaveMegaMenu, contentLink }) => {
    const dispatch = useDispatch();
    const blockAreaRef = useRef(null);

    useEffect(() => {
        if(open) {
            dispatch(addOverlay("MegaMenu", onMegaMenuClose));
        }else{
            dispatch(removeOverlay("MegaMenu"));
        }
    }, [open])

    const blocks = blockElements && contentLink.blocks ? blockElements.filter(b => contentLink.blocks.indexOf(b.dataset["litiumBlockId"]) != -1) : null;
    const hasBlocks = blocks && blocks.length > 0;

    useEffect(() => {
        if(!blockAreaRef || !blockAreaRef.current || !hasBlocks) return;
        for(let block of blocks) {
            if (block.parentNode !== blockAreaRef.current) {
                blockAreaRef.current.appendChild(block);
            }
        }
    }, [blocks])

    const linksColumnCount = hasBlocks ? Math.floor(12 - blockSectionColumnSize) : 12;
    const linksColumnClass = `small-${linksColumnCount}`;

    const getLinkGroups = () => {
        const groupSections = [];
        
        let currentGroupContainer = null;

        for(let idx in contentLink.links) {
            let group = contentLink.links[idx];

            // If group has a column count of two, create a separate group container for this group
            if(group.columnCount == 2) {
                if(currentGroupContainer) {
                    groupSections.push(currentGroupContainer);
                    currentGroupContainer = null;
                }
                groupSections.push([group]);
            }else{
                if(!currentGroupContainer) {
                    // Create container if not already
                    currentGroupContainer = [];
                }
                
                // Add this group to the current group container
                currentGroupContainer.push(group);

                // Push to array if last group
                if(idx == contentLink.links.length-1) {
                    groupSections.push(currentGroupContainer);
                }
            }
        }

        return groupSections.map((section, idx) => 
            <div key={`${contentLink.name}-section-${idx}`} className={`mega-menu__group ${section.length == 1 ? 'mega-menu__group--two-columns' : ''}`}>
                {section.map(g => <Fragment key={`group-${g.name}`}>
                    <div className='mega-menu__group-header' key={g.name}>{g.name}</div>
                    <div className='mega-menu__group-links'>
                        {g.links.map(link => <a key={`${g.name}${link.name}`} href={link.url}>{link.name}</a>)}
                    </div>
            </Fragment>)}
            </div>
        );
    }

    // Make blocks take full row if we can't fit links and blocks on the same row
    const blockColumnClass = `small-${linksColumnCount < 2 ? 12 : blockSectionColumnSize}`;

    return <div className={`mega-menu show-for-medium-large ${open ? 'mega-menu--open' : ''}`} onMouseLeave={onMouseLeaveMegaMenu} onMouseOver={onMouseOverMegaMenu}>
        <div className='row'>
            {(linksColumnCount >= 2 || !hasBlocks) && <div className={`mega-menu__groups ${linksColumnClass}`}>
                {getLinkGroups()}
            </div>}
            {hasBlocks && <div className={`mega-menu__block-area ${blockColumnClass}`}>
                {contentLink.blockSectionTitle && <div className='mega-menu__group-header'>{contentLink.blockSectionTitle}</div>}
                <div ref={blockAreaRef}></div>
            </div>}
        </div>
    </div>
}